import http from "@/utils/http";
// 用户注册相关接口

// 获取展会海报信息
export function getExhibitionPosterInfo(headers, meetingCode) {
  const config = {
    method: "GET",
    url: `/user/hold/exhibition/poster/${meetingCode}`,
    headers,
  };
  return http(config);
}

// 获取办个会海报信息
export function getHoldMeetPosterInfo(headers, meetingCode) {
  const config = {
    method: "GET",
    url: `/user/hold/meeting/poster/${meetingCode}`,
    headers,
  };
  return http(config);
}

export function getHoldMeetSignPosterInfo(headers, meetingCode, type) {
  let url = `/user/hold/meeting/exhibition/qrCode/${meetingCode}?meetingType=HOLD_MEETING`;
  const config = {
    method: "GET",
    url: url,
    headers,
  };
  return http(config);
}

// 获取论坛海报信息
export function getForumPosterInfo(headers, meetingCode) {
  const config = {
    method: "GET",
    url: `/user/meeting/forum/poster/${meetingCode}`,
    headers,
  };
  return http(config);
}

// 获取论坛签到海报信息
export function getHoldMeetForumSignPosterInfo(headers, meetingCode, type) {
  let url = `/user/hold/meeting/exhibition/qrCode/${meetingCode}?meetingType=FORUM`;

  const config = {
    method: "GET",
    url: url,
    headers,
  };
  return http(config);
}

// 获取动态详情
export function getTrendDetail(headers, id) {
  let url = `/user/publish/queryPublishById/${id}`;

  const config = {
    method: "GET",
    url: url,
    headers,
  };
  return http(config);
}

// 获取用户名片信息
export function getMyUserInfo(headers, params) {
  let url = `user/homepage/queryMyHomepage`;

  const config = {
    method: "GET",
    url: url,
    headers,
    params,
  };
  return http(config);
}

// 获取他人名片信息
export function getOtherUserInfo(headers, uid, params) {
  let url = `user/homepage/queryUserHomepage?uid=${uid}`;

  const config = {
    method: "GET",
    url: url,
    headers,
    params
  };
  return http(config);
}

// 获取 企业二维码接口

export function getEnterPriseQrcode(headers, params) {
  let url = `/user/enterprise/query/qrcode`;

  const config = {
    method: "GET",
    url: url,
    headers,
    params,
  };
  return http(config);
}

// 获取企业信息接口
export function getEnterpriseHomePage(headers, enterpriseCode) {
  let url = `/user/enterprise/homepage?enterpriseCode=${enterpriseCode}`;

  const config = {
    method: "GET",
    url: url,
    headers,
  };
  return http(config);
}
/**
 * @description: 获取企业场景信息接口
 * @param {*} headers
 * @param {*} params
 * @return {*}
 */
export function handleEnterpriseCodeByScene(headers, params) {
  let url = `/user/enterprise/query/meetingScene`;

  const config = {
    method: "GET",
    url: url,
    headers,
    params,
  };
  return http(config);
}

//获取办个会海报接口
export function getMeetingPoster(headers, meetingCode) {
  let url = `/user/hold/meeting/poster/${meetingCode}`;

  const config = {
    method: "GET",
    url: url,
    headers,
  };
  return http(config);
}

// 获取办个展的海报接口
export function exhibitionPoster(headers, exhibitionCode) {
  let url = `/user/hold/exhibition/poster/${exhibitionCode}`;

  const config = {
    method: "GET",
    url: url,
    headers,
  };
  return http(config);
}
